module.exports = __webpack_public_path__ + "static/images/lookingGlass.a4815aee9afa998d20ee5b248ddcd831.svg";